export default __webpack_public_path__ + "static/img_good_team@2x-0c602830699c5ba76112cf977cf905eb.png";